var render = function render(){var _vm=this,_c=_vm._self._c;return _c('youtube',{ref:"youtube",staticClass:"yt-iframe",style:(`${_vm.maxHeight}${_vm.fullScreenClass}`),attrs:{"video-id":_vm.getId(),"resize":true,"attrs":{'allowfullscreen': true},"allow":"fullscreen"},on:{"playing":_vm.playing}})
}
var staticRenderFns = []

export { render, staticRenderFns }